export default __webpack_public_path__ + "static/media/scik.e2e76dcc.png";